const router = {
  path: '/rnr/person',
  name: 'RnrPerson',
  meta: { title: '自然人实名认证', type: 'business' },
  component: () => import('@/components/Layout'),
  children: [
    {
      path: '/rnr/person/card',
      name: 'RnrPersonCard',
      meta: { title: '填写车卡信息', type: 'business' },
      component: () => import('@/views/rnr/person/card')
    },
    {
      path: '/rnr/person/base',
      name: 'RnrPersonBase',
      meta: { title: '身份信息', type: 'business' },
      component: () => import('@/views/rnr/person/base')
    },
    {
      path: '/rnr/person/idcard',
      name: 'RnrPersonIdcard',
      meta: { title: '证件信息', type: 'business' },
      component: () => import('@/views/rnr/person/idcard')
    },
    {
      path: '/rnr/person/paper',
      name: 'RnrPersonPaper',
      meta: { title: '证件信息', type: 'business' },
      component: () => import('@/views/rnr/person/paper')
    },
    {
      path: '/rnr/person/consigner-base',
      name: 'RnrPersonConsignerBase',
      meta: { title: '代办人身份信息', type: 'business' },
      component: () => import('@/views/rnr/person/consigner-base')
    },
    {
      path: '/rnr/person/consigner-idcard',
      name: 'RnrPersonConsignerIdcard',
      meta: { title: '代办人证件信息', type: 'business' },
      component: () => import('@/views/rnr/person/consigner-idcard')
    },
    {
      path: '/rnr/person/consigner-paper',
      name: 'RnrPersonConsignerPaper',
      meta: { title: '代办人证件信息', type: 'business' },
      component: () => import('@/views/rnr/person/consigner-paper')
    },
    {
      path: '/rnr/person/file',
      name: 'RnrPersonFile',
      meta: { title: '文件信息', type: 'business' },
      component: () => import('@/views/rnr/person/file')
    },
    {
      path: '/rnr/person/notification',
      name: 'RnrPersonNotification',
      // meta: { title: '责任告知书', type: 'business' },
      meta: { title: '实名认证隐私政策与责任告知书', type: 'business' },
      component: () => import('@/views/rnr/person/notification')
    },
    {
      path: '/rnr/person/agreement',
      name: 'RnrPersonAgreement',
      meta: { title: '入网协议', type: 'business' },
      component: () => import('@/views/rnr/person/agreement')
    },
    {
      path: '/rnr/person/result',
      name: 'RnrPersonResult',
      meta: { title: '校验结果', type: 'business' },
      component: () => import('@/views/rnr/person/result')
    },
    {
      path: '/rnr/person/user-info-agreement',
      name: 'RnrPersonUserInfoAgreement',
      component: () => import('@/views/rnr/person/user-info-agreement'),
      meta: { title: '个人信息保护政策共享条款' }
    }
  ]
}

export default router



// WEBPACK FOOTER //
// ./src/router/person-rnr.js